/**
 * Sessie 53 blok 1 (G2): een al verstuurd concept is geen concept.
 *
 * Op een zaak waarop Sanne of JP al antwoordde, geeft `/concept` de mail
 * terug die uitging, met `afgerond` en `bron: "verstuurd"`. Kaart en kop
 * zeggen dan "geen concept"; het vak dus ook. Die tekst komt nooit in een
 * vak dat verstuurd kan worden.
 */
import type { TegelConcept } from "../api";

/** De zaak is al beantwoord, of de tekst is de mail die al uitging. */
export function conceptIsVerstuurd(concept: TegelConcept | null | undefined): boolean {
  return Boolean(concept && (concept.afgerond || concept.bron === "verstuurd"));
}

/**
 * Het concept zoals het vak het mag gebruiken. Alle standen lezen hun
 * begintekst hieruit; een al verstuurd concept wordt een leeg concept.
 */
export function vakConcept(concept: TegelConcept): TegelConcept {
  if (!conceptIsVerstuurd(concept)) return concept;
  // Ook de bijlagen van dat concept (sessie 55) horen niet meer in het vak.
  return { ...concept, tekst: "", bron: "leeg", concept_bijlagen: null };
}
